import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/Carousel';
import { FormControl, FormField } from '@/components/ui/Form';
import { Card, CardContent, CardHeader, CardHeaderImage, CardText, Form, FormItem } from '@/components/wm';
import { zodResolver } from '@hookform/resolvers/zod';
import * as React from 'react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export function OrganizationTypeForm({ data, onChangeField, onCompleted }) {
    const options = [
        {
            title: i18next.t('organizations.type.buildings'),
            organizationType: 'building',
            description: i18next.t('organizations.type.buildings_desc')
        },
        {
            title: i18next.t('organizations.type.retail'),
            organizationType: 'retail',
            description: i18next.t('organizations.type.retail_desc')
        },
        {
            title: i18next.t('organizations.type.industry'),
            organizationType: 'industry',
            description: i18next.t('organizations.type.industry_desc')
        }
    ];

    const formSchema = z.object({
        organizationType: z.string().min(1, i18next.t('form_validations.organization_type.type_required'))
    });

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            organizationType: data.organizationType || ''
        },
        mode: 'onChange'
    });

    useEffect(() => {
        onCompleted(form.formState.isValid);
    }, [form.formState.isValid]);

    return (
        <Form {...form} className="!tw-max-w-full !tw-max-h-1/4">
            <FormField
                control={form.control}
                name="organizationType"
                render={({ field }) => (
                    <FormItem>
                        <FormControl>
                            <Carousel opts={{ loop: true }}>
                                <CarouselContent>
                                    {options.map((option, index) => (
                                        <CarouselItem
                                            className="tw-flex tw-justify-center tw-items-center tw-rounded-lg tw-p-4 md:!tw-basis-1/2 lg:!tw-basis-1/3"
                                            key={index}
                                        >
                                            <Card
                                                className={`tw-p-4 tw-h-full tw-cursor-pointer ${option.organizationType === data.organizationType ? 'tw-bg-primary' : 'hover:tw-border-primary'}`}
                                                onClick={() => {
                                                    field.onChange(option.organizationType);
                                                    onChangeField('organizationType')(option.organizationType);
                                                }}
                                            >
                                                <CardHeaderImage>
                                                    <img className="tw-max-h-[200px] tw-mx-auto" src={`/images/misc/${option.organizationType}.png`}/>
                                                </CardHeaderImage>
                                                <CardHeader className={`${option.organizationType === data.organizationType ? 'tw-text-white' : ''}`} title={option.title}/>
                                                <CardContent>
                                                    <CardText>
                                                        {option.description}
                                                    </CardText>
                                                </CardContent>
                                            </Card>
                                        </CarouselItem>
                                    ))}
                                </CarouselContent>

                                <CarouselPrevious className="lg:tw-hidden"/>
                                <CarouselNext className="lg:tw-hidden"/>
                            </Carousel>
                        </FormControl>
                    </FormItem>
                )}
            />
        </Form>
    );
}
